export enum CustomShiftsRoutesEnum{
    SHIFTS_PREFIX   = 'custom-shifts',
    SHIFTS_LIST     = 'custom-shifts_list',
    SHIFTS_DETAIL   = 'custom-shifts_detail',
}